import { field, scope, vector } from '../instructions';
import { ContextTransformFieldIndex, ListPatternPositionIndex } from '../schema/general';
export var LAYOUT = scope('Layout', 'Layout', [field('characterOrder'), field('lineOrder')]);
var listPattern = function (name) { return vector(name, ['list-pattern-position']); };
export var LIST_PATTERNS = scope('ListPatterns', 'ListPatterns', [
    listPattern('and'),
    listPattern('andShort'),
    listPattern('or'),
    listPattern('unitLong'),
    listPattern('unitNarrow'),
    listPattern('unitShort'),
]);
export var GENERAL_INDICES = {
    'context-transform-field': ContextTransformFieldIndex,
    'list-pattern-position': ListPatternPositionIndex,
};
export var CONTEXT_TRANSFORM = scope('ContextTransforms', 'ContextTransforms', [
    vector('contextTransforms', ['context-transform-field']),
]);
//# sourceMappingURL=general.js.map